import Step from '@mui/material/Step'
import StepContent from '@mui/material/StepContent'
import StepLabel from '@mui/material/StepLabel'
import Stepper from '@mui/material/Stepper'

Stepper.Step = Step
Stepper.Label = StepLabel
Stepper.Content = StepContent

export default Stepper
